// AssistanceMenuCard.tsx

import React from 'react';
import '../../styles/AssistanceMenuCard.css';
import { MdArrowForward, MdBuild } from 'react-icons/md';
import { FaUser } from 'react-icons/fa';

export type AssistanceMenuCardProps = {
  id: string;
  status: {
    label: string;
    color: 'yellow' | 'green' | 'red' | 'blue';
  };
  client: string;
  equipment: string;
  technician: string;
  onClick?: () => void;
};

const statusColorMap: Record<string, string> = {
  yellow: 'assistance-card__status--yellow',
  green: 'assistance-card__status--green',
  red: 'assistance-card__status--red',
  blue: 'assistance-card__status--blue',
};

export const AssistanceMenuCard: React.FC<AssistanceMenuCardProps> = ({
  id,
  status,
  client,
  equipment,
  technician,
  onClick,
}) => {
  return (
    <button
      className="assistance-card"
      tabIndex={0}
      onClick={onClick}
    >
      <div className={`assistance-card__side ${statusColorMap[status.color]}`}></div>
      <div className="assistance-card__content">
        <div className="assistance-card__header">
          <span className="assistance-card__id">#{id}</span>
          <span className={`assistance-card__status-badge assistance-card__status-badge--${status.color}`}>
            <span className={`assistance-card__status-dot assistance-card__status-dot--${status.color}`}></span>
            {status.label}
          </span>
        </div>
        <h3 className="assistance-card__client">{client}</h3>
        <div className="assistance-card__info">
          <div className="assistance-card__info-row">
            <span className="assistance-card__icon"><MdBuild size={18} /></span>
            <span className="assistance-card__info-label">{equipment}</span>
          </div>
          <div className="assistance-card__info-row">
            <span className="assistance-card__icon"><FaUser size={16} /></span>
            <span className="assistance-card__info-label">{technician}</span>
          </div>
        </div>
      </div>
      <span className="assistance-card__arrow">
        <MdArrowForward size={22} />
      </span>
    </button>
  );
};
